// src/services/overhead.js
import { API_BASE_URL } from './api-config';

export const overheadAPI = {
  // Get all expenses
  getExpenses: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.category && filters.category !== 'All') params.append('category', filters.category);
      if (filters.status  && filters.status  !== 'All') params.append('status',   filters.status);
      if (filters.year) params.append('year', filters.year);

      const url = `${API_BASE_URL}/overhead/list.php${params.toString() ? '?' + params.toString() : ''}`;
      const response = await fetch(url, { method: 'GET', credentials: 'include' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('getExpenses error:', error);
      throw error;
    }
  },

  // Create expense
  createExpense: async (expenseData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/create.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(expenseData),
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`HTTP ${response.status}: ${text}`);
      }
      return response.json();
    } catch (error) {
      console.error('createExpense error:', error);
      throw error;
    }
  },

  // ✅ Update expense (resets status to Pending)
  updateExpense: async (expenseData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/update.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(expenseData),
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`HTTP ${response.status}: ${text}`);
      }
      return response.json();
    } catch (error) {
      console.error('updateExpense error:', error);
      throw error;
    }
  },

  // Delete expense
  deleteExpense: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/delete.php?id=${id}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('deleteExpense error:', error);
      throw error;
    }
  },

  // Approve/Reject expense
  approveExpense: async (id, status, note = null) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/approve.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id, status, note }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('approveExpense error:', error);
      throw error;
    }
  },

  // Get statistics
  getStats: async (year) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/stats.php?year=${year}`, {
        method: 'GET',
        credentials: 'include',
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('getStats error:', error);
      return { success: true, data: { year, yearTotal: 0, avgMonthly: 0, monthly: [] } };
    }
  },

  // Upload file
  uploadFile: async (expenseId, file) => {
    try {
      const formData = new FormData();
      formData.append('expense_id', expenseId);
      formData.append('file', file);
      const response = await fetch(`${API_BASE_URL}/overhead/upload-file.php`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('uploadFile error:', error);
      throw error;
    }
  },

  // Get files for expense
  getFiles: async (expenseId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/get-files.php?expense_id=${expenseId}`, {
        method: 'GET',
        credentials: 'include',
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('getFiles error:', error);
      return { success: true, data: [] };
    }
  },

  // Delete file
  deleteFile: async (fileId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/overhead/delete-file.php?id=${fileId}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    } catch (error) {
      console.error('deleteFile error:', error);
      throw error;
    }
  },
};